// const urlRoot = 'http://localhost:50598'
const urlRoot = '/api'
export default {
    // Endpoints

    analysisQueryEndpoint: `${urlRoot}/setting/analysisQuery`,
    memTypeAnalysisQueryEndpoint: `${urlRoot}/setting/memTypeAnalysisQuery`,
    memTypeAnalysisQueryChartEndpoint: `${urlRoot}/setting/memTypeAnalysisQueryChart`,
    winAnalysisQueryEndpoint: `${urlRoot}/setting/winAnalysisQuery`,
    memTransferEndpoint: `${urlRoot}/setting/MemTransferInfo`,
    memTransferUpdateEndpoint: `${urlRoot}/setting/MemTransferInfoUpdate`,
    cancelticketEndpoint: `${urlRoot}/setting/cancelticket`,
    resumeTicketEndpoint: `${urlRoot}/setting/resumeTicket`,
    returnTicketEndpoint: `${urlRoot}/setting/returnTicket`,
    batchReturnTicketEndpoint: `${urlRoot}/setting/batchReturnTicket`,
    returnEvtIDsTicketEndpoint: `${urlRoot}/setting/returnEvtIDsTicket`,
    resetDepositEndpoint: `${urlRoot}/setting/resetDeposit`,

    acquNoMatchEndpoint: `${urlRoot}/setting/acquNoMatch`,
    acquMatchGameSDateEndpoint: `${urlRoot}/setting/acquMatchGameSDate`,
    acquMatchGameEndpoint: `${urlRoot}/setting/acquMatchGame`,

    checkNoMatchGameResultQueryEndpoint: `${urlRoot}/setting/checkNoMatchGameResultQuery`,
    checkNoMatchGameResultSelectGameDataEndpoint: `${urlRoot}/setting/checkNoMatchGameResultSelectGameData`,
    checkNoMatchGameResultEndpoint: `${urlRoot}/setting/checkNoMatchGameResult`,

    selectOptionsEndpoint: `${urlRoot}/setting/selectOptions`,
    tourQueryEndpoint: `${urlRoot}/setting/tourQuery`,
    tourMCQueryEndpoint: `${urlRoot}/setting/tourMCQuery`,
    queryByLNameEndpoint: `${urlRoot}/setting/queryByLName`,
    tourInsertEndpoint: `${urlRoot}/setting/tourInsert`,
    tourUpdateEndpoint: `${urlRoot}/setting/tourUpdate`,
    tourUpdateModIDEndpoint: `${urlRoot}/setting/tourUpdateModID`,
    tourDeleteEndpoint: `${urlRoot}/setting/tourDelete`,

    betSettingQueryEndpoint: `${urlRoot}/setting/betSettingQuery`,
    betSettingInsertEndpoint: `${urlRoot}/setting/betSettingInsert`,
    betSettingUpdateEndpoint: `${urlRoot}/setting/betSettingUpdate`,
    betSettingDeleteEndpoint: `${urlRoot}/setting/betSettingDelete`,

    teamQueryEndpoint: `${urlRoot}/setting/teamQuery`,
    teamInsertEndpoint: `${urlRoot}/setting/teamInsert`,
    teamUpdateEndpoint: `${urlRoot}/setting/teamUpdate`,
    teamDeleteEndpoint: `${urlRoot}/setting/teamDelete`,

    teamPQueryEndpoint: `${urlRoot}/setting/teamPQuery`,
    teamPInsertEndpoint: `${urlRoot}/setting/teamPInsert`,
    teamPUpdateEndpoint: `${urlRoot}/setting/teamPUpdate`,
    teamPDeleteEndpoint: `${urlRoot}/setting/teamPDelete`,

    liveScoutLightRuleQueryEndpoint: `${urlRoot}/setting/liveScoutLightRuleQuery`,
    liveScoutLightRuleInsertEndpoint: `${urlRoot}/setting/liveScoutLightRuleInsert`,
    liveScoutLightRuleUpdateEndpoint: `${urlRoot}/setting/liveScoutLightRuleUpdate`,
    liveScoutLightRuleDeleteEndpoint: `${urlRoot}/setting/liveScoutLightRuleDelete`,

    oddsConfigQueryEndpoint: `${urlRoot}/setting/oddsConfigQuery`,
    oddsConfigUpdateEndpoint: `${urlRoot}/setting/oddsConfigUpdate`,

    oddsDefaultQueryEndpoint: `${urlRoot}/setting/oddsDefaultQuery`,
    oddsDefaultUpdateEndpoint: `${urlRoot}/setting/oddsDefaultUpdate`,

    siteMaintainQueryEndpoint: `${urlRoot}/setting/siteMaintainQuery`,
    siteMaintainUpdateEndpoint: `${urlRoot}/setting/siteMaintainUpdate`,

    sp66MEndpoint: `${urlRoot}/setting/sp66M`,
    sp66UMEndpoint: `${urlRoot}/setting/sp66UM`,
    getMEndpoint: `${urlRoot}/setting/getM`,

    getMemCashFlowEndpoint: `${urlRoot}/setting/getMemCashFlow`,
    modifyMemCashFlowEndpoint: `${urlRoot}/setting/modifyMemCashFlow`,

    currencyListEndpoint: `${urlRoot}/setting/currencyList`,
    currencyInfoEndpoint: `${urlRoot}/setting/currencyInfo`,
    currencyInsertEndpoint: `${urlRoot}/setting/currencyInsert`,
    currencyUpdateEndpoint: `${urlRoot}/setting/currencyUpdate`,
    currencyDeleteEndpoint: `${urlRoot}/setting/currencyDelete`,
    currencyActiveEndpoint: `${urlRoot}/setting/currencyActive`,
    currencyLogLlistEndpoint: `${urlRoot}/setting/currencyLogLlist`,

    marginListEndpoint: `${urlRoot}/setting/marginList`,
    marginUpdateEndpoint: `${urlRoot}/setting/marginUpdate`,
    marginRemoveEndpoint: `${urlRoot}/setting/marginRemove`,

    otherControlQueryEndpoint: `${urlRoot}/setting/otherControlQuery`,
    limitControlQueryEndpoint: `${urlRoot}/setting/limitControlQuery`,
    otherControlSaveEndpoint: `${urlRoot}/setting/otherControlSave`,
    limitControlSaveEndpoint: `${urlRoot}/setting/limitControlSave`,
    parlayMaxWinQueryEndpoint: `${urlRoot}/setting/parlayMaxWinQuery`,
    parlayMaxWinSaveEndpoint: `${urlRoot}/setting/parlayMaxWinSave`,

    sysConfigQueryEndpoint: `${urlRoot}/SysConfig/query`,
    sysConfigInsertEndpoint: `${urlRoot}/SysConfig/insert`,
    sysConfigUpdateEndpoint: `${urlRoot}/SysConfig/update`,
    sysConfigDeleteEndpoint: `${urlRoot}/SysConfig/delete`,
}
